namespace advisorop.components.identity {
   
    export class IdentityAppController {
        returnUrl;
        constructor() {
        }


        $onInit(): void {
            //console.log(this.returnUrl);
            if (this.returnUrl)
                localStorage.setItem("returnUrl", this.returnUrl);
        }

        $routerOnActivate(next, previous) {
            //console.log("-------------- routerOnActivated --------------");
            //console.log(next);
            //console.log(previous);            
        }
    }



    class IdentityApp implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                returnUrl: "<"
            };
            this.controller = IdentityAppController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/identity-module/components/identity-app.html';

            this.$routeConfig = [
                { path: "/login", component: "loginFormContainer", name: "Login" },
                { path: "/login/:uiType", component: "loginFormContainer", name: "Login3" },
                // Above the /:ReturnUrl catch-all, which would otherwise swallow it.
                { path: "/choose-account", component: "ssoAccountChooser", name: "SsoChooseAccount" },
                { path: "/:ReturnUrl", component: "loginFormContainer", name: "Login2" },
                { path: "/forgot-password", component: "forgotPasswordForm", name: "ForgotPassword" },
                { path: "/reset-password/:userId/:code", component: "resetPasswordForm", name: "ResetPassword" },
                { path: "/setup-account/:userId/:code", component: "setupAccountForm", name: "SetupAccount" },
                { path: "/logout", component: "loginFormContainer", name: "Logout" },
                { path: "/access-denied", component: "accessDeniedForm", name: "AccessDenied" },
                { path: "/**", redirectTo: ["Login"] }
            ];
        }

    }
    angular.module(Constants.APP).component("identityApp", new IdentityApp());


}